<div class="d-none d-lg-block d-xl-block">
  <div ngbDropdown [container]="container" class="d-inline-block w-100" (openChange)="onOpen($event)">
    <button class="btn btn-ddl dropdown-toggle w-100 wrap-selected" id="{{id}}" ngbDropdownToggle>
      <div class="selected-value">
        {{selectedItem?.label}}
      </div>
    </button>
    <div ngbDropdownMenu attr.aria-labelledby="{{id}}" class="dropdown-menu">
      <button ngbDropdownItem *ngFor="let item of items"
              [class.active]="selectedItem?.id === item.id"
              (click)="onDdlItemClick(item)">
        {{ item.label }}
      </button>
    </div>
  </div>
</div>
<div class="custom-native-dropdown wrap-selected d-lg-none d-xl-none">
  <select class="select-native btn-ddl selected-value" name="select-native"
          id="m-{{id}}"
          [(ngModel)]="selectedItem"
          (change)="onDdlItemClick(selectedItem)">
    <option *ngFor="let item of items"
            [ngValue]="item"
            [selected]="selectedItem?.id === item.id">
      {{ item.label }}
    </option>
  </select>
  <div class="custom-dropdown-arrow" [ngClass]="{'width65': width === 65, 'width5': width === -5}">
    <div class="arrow"></div>
  </div>
</div>
